import moment from 'moment';

/**
 * Converts a Date object that represents UTC time to the local device timezone
 * @param utcDate - A Date object representing UTC time
 * @returns A Date object adjusted to the local device timezone
 */
export function convertUtcToLocal(utcDate: Date): Date {
    if (!utcDate || !(utcDate instanceof Date) || isNaN(utcDate.getTime())) {
        return utcDate;
    }

    // Create a moment object from the UTC date and convert to local timezone
    const localMoment = moment.utc(utcDate).local();
    return localMoment.toDate();
}

/**
 * Ensures a date is in local timezone for display purposes
 * @param date - A Date object that may be in UTC
 * @returns A Date object in local timezone
 */
export function ensureLocalTimezone(date: Date): Date {
    if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
        return date;
    }

    // For safety, always treat server dates as UTC and convert to local
    // This is the most reliable approach for notification timestamps
    return convertUtcToLocal(date);
}
